/**
 * Single source of truth for formatting durations across the portal.
 * Input: minutes (number). Output: human-friendly string like "1h 30min",
 * "45min", "2h", "3d 5h" — never raw minutes once the total exceeds 60.
 *
 * Used by every screen that surfaces delays, ETAs, breakdown durations,
 * paused-for indicators etc.
 */
export function fmtDuration(totalMinutes, opts = {}) {
    const { dash = "—" } = opts;
    if (totalMinutes == null || isNaN(totalMinutes)) return dash;
    const sign = totalMinutes < 0 ? "-" : "";
    let m = Math.max(0, Math.round(Math.abs(totalMinutes)));
    if (m === 0) return "0min";
    const days = Math.floor(m / 1440);
    m -= days * 1440;
    const hours = Math.floor(m / 60);
    const minutes = m - hours * 60;
    // Preferred user format: "1h:30min", "3h", "45min", or "2d 5h:10min"
    const hm = hours > 0 && minutes > 0
        ? `${hours}h:${minutes}min`
        : hours > 0
        ? `${hours}h`
        : `${minutes}min`;
    return sign + (days > 0 ? `${days}d ${hm}` : hm);
}

/** Compact for tight UI (eg pill badges). Same logic, drops "min" suffix when h is present. */
export function fmtDurationCompact(totalMinutes) {
    return fmtDuration(totalMinutes);
}
